module.exports = __webpack_public_path__ + "img/IR.b8a49ef.jpg";